import { useUserData } from "components/customHooks/userDataContext";
import useSnackbar from "components/customHooks/useSnackbar";
// import useTimer from "components/customHooks/useTimer";
import React, { useState, useEffect } from "react";
import { TextField, Popover } from "@mui/material";
import { handleClockIn } from "apiHandler/actions";

const CheckInOutButton = () => {
  const [isCheckedin, setIsCheckedIn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(
    `${new Date().toISOString().slice(0, 10)}T${new Date()
      .toLocaleTimeString("en-US", { hour12: false })
      .slice(0, 5)}`
  );
  const { CustomSnackbar, setSnackbarMessage } = useSnackbar();
  // const { timer, handleStart, handleReset } = useTimer({});
  const userData = useUserData();

  useEffect(() => {
    // const fetchData = async () => {
    //   const payload = {};
    //   const response = await checkIsCheckedIn(payload, userData?.access_token);
    //   if (response) setIsCheckedIn(true);
    // };
    // fetchData();
  }, []);

  const onClick = async () => {
    if (loading) return;
    setAnchorEl(null);
    setLoading(true);
    if (isCheckedin) {
      const payload = {
        type: "Check Out",
        date: date.slice(0, 10),
        time: date.slice(11, 16),
      };
      const response = await handleClockIn(payload, userData?.access_token);
      if (response) {
        setIsCheckedIn(false);
        // handleReset();
      } else {
        setSnackbarMessage("Failed to check out. Please try again later!");
      }
    } else {
      const payload = {
        type: "Check In",
        date: date.slice(0, 10),
        time: date.slice(11, 16),
      };
      const response = await handleClockIn(payload, userData?.access_token);
      if (response) {
        setIsCheckedIn(true);
        // handleStart();
      } else {
        setSnackbarMessage("Failed to check in. Please try again later!");
      }
    }
    setLoading(false);
  };
  // For Popover
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <CustomSnackbar />
      <button
        id={id}
        className={`check-in-btn ${isCheckedin ? "user-checked-in" : ""} `}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {loading ? "Loading" : isCheckedin ? "Check Out" : "Check In"}
      </button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="check-in-popover">
          <TextField
            id="time"
            type="datetime-local"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              step: 300, // 5 min
            }}
          />
          <button className="button" onClick={onClick}>
            {isCheckedin ? "Check Out" : "Check In"}
          </button>
        </div>
      </Popover>
    </>
  );
};

export default CheckInOutButton;
